import React from "react";
import { Form, FormGroup, Label, Input, Button, Row, Col } from "reactstrap";
import { validateUrl } from "../utils/validateUrl";

const ECC_LEVELS = ["L", "M", "Q", "H"];

const QRControls = ({ value, onChange, onReset }) => {
  const fileInputRef = React.useRef(null);
  const isValid = validateUrl(value.url);

  const onLogoChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // ป้องกัน SVG (ยังไม่รองรับ preview บน canvas)
    const isSvg = file.type === "image/svg+xml" || /\.svg$/i.test(file.name);
    if (isSvg) {
      alert(
        "ตอนนี้ยังไม่รองรับไฟล์ SVG สำหรับพรีวิวบนแคนวาส กรุณาใช้ PNG/JPG/WebP"
      );
      e.target.value = "";
      return;
    }

    // ตรวจสอบขนาดไฟล์ไม่เกิน 512KB
    if (file.size > 512 * 1024) {
      alert("ไฟล์โลโก้ควรมีขนาดไม่เกิน 512KB");
      e.target.value = ""; // reset file input
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      onChange({ logoDataUrl: reader.result });
    };
    reader.readAsDataURL(file);
  };

  const removeLogo = () => {
    onChange({ logoDataUrl: "" });
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  return (
    <Form>
      <FormGroup>
        <Label for="qrUrl">ลิงก์ URL</Label>
        <Input
          id="qrUrl"
          placeholder="เช่น https://www.google.com/"
          value={value.url}
          onChange={(e) => onChange({ url: e.target.value })}
          invalid={!!value.url && !isValid}
        />
        {!isValid && value.url && (
          <small className="text-danger">
            ต้องขึ้นต้นด้วย http:// หรือ https://
          </small>
        )}
      </FormGroup>

      <Row>
        <Col md="6">
          <FormGroup>
            <Label for="qrSize">ขนาด (px)</Label>
            <Input
              id="qrSize"
              type="number"
              min={128}
              max={1024}
              step={1}
              value={value.size}
              onChange={(e) =>
                onChange({
                  size: Math.max(
                    128,
                    Math.min(1024, Number(e.target.value) || 256)
                  ),
                })
              }
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label for="qrMargin">ระยะขอบ (modules)</Label>
            <Input
              id="qrMargin"
              type="number"
              min={0}
              max={16}
              step={1}
              value={value.margin}
              onChange={(e) =>
                onChange({
                  margin: Math.max(
                    0,
                    Math.min(16, Number(e.target.value) || 4)
                  ),
                })
              }
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <Label for="qrECC">ระดับการแก้ไขข้อผิดพลาด (ECC)</Label>
            <Input
              id="qrECC"
              type="select"
              value={value.ecc}
              onChange={(e) => onChange({ ecc: e.target.value })}
            >
              {ECC_LEVELS.map((lv) => (
                <option key={lv} value={lv}>
                  {lv}
                </option>
              ))}
            </Input>
            <small className="text-muted">
              H ทนทานที่สุด (โลโก้ใหญ่ขึ้นได้) แต่ลายแน่น
            </small>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <Label for="fgColor">สีลาย (Foreground)</Label>
            <Input
              id="fgColor"
              type="color"
              value={value.fgColor}
              onChange={(e) => onChange({ fgColor: e.target.value })}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label for="bgColor">สีพื้นหลัง (Background)</Label>
            <Input
              id="bgColor"
              type="color"
              value={value.bgColor}
              onChange={(e) => onChange({ bgColor: e.target.value })}
            />
          </FormGroup>
        </Col>
      </Row>

      <FormGroup>
        <Label>โลโก้ตรงกลาง (ออปชัน)</Label>
        <div className="d-flex align-items-center gap-2">
          <Button
            color="secondary"
            outline
            onClick={() => fileInputRef.current?.click()}
          >
            อัปโหลดโลโก้
          </Button>
          {value.logoDataUrl && (
            <>
              <img
                src={value.logoDataUrl}
                alt="logo-preview"
                style={{
                  width: 36,
                  height: 36,
                  objectFit: "contain",
                  borderRadius: 6,
                }}
              />
              <Button color="danger" outline onClick={removeLogo}>
                ลบโลโก้
              </Button>
            </>
          )}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/png, image/jpeg, image/webp"
            style={{ display: "none" }}
            onChange={onLogoChange}
          />
        </div>
        <small className="text-muted d-block mt-1">
          กรุณาใช้ PNG/JPG/WebP เท่านั้น
        </small>
        <small className="text-muted d-block mt-1">
          ไม่สามารถอัพโหลดรูปได้มากกว่า 512 KB (≤ 512KB)
        </small>
      </FormGroup>

      <div className="d-flex gap-2">
        {/* <Button
          type="button"
          color="dark"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          ขึ้นบน
        </Button> */}
        <Button type="button" color="secondary" outline onClick={onReset}>
          รีเซ็ตค่าเริ่มต้น
        </Button>
      </div>
    </Form>
  );
};

export default QRControls;
